import { useState } from 'react'
import type { CustomFieldDefinition } from '../../orders/api/intakeApi'
import { IntakeFieldRenderer } from '../../../shared/components/IntakeFieldRenderer'

interface FieldPreviewProps {
  fields: CustomFieldDefinition[]
}

/**
 * Live preview: renders the configured fields exactly as the customer sees them
 * in the intake form, using the shared IntakeFieldRenderer.
 */
export function FieldPreview({ fields }: FieldPreviewProps) {
  const [values, setValues] = useState<Record<string, unknown>>({})

  const handleChange = (key: string, value: unknown) => {
    setValues((prev) => ({ ...prev, [key]: value }))
  }

  return (
    <div className="rounded-lg border border-blue-200 bg-blue-50/40">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-blue-100">
        <span className="text-sm font-semibold text-foreground">Customer Preview</span>
        <span className="text-xs text-muted-foreground">How these fields appear in the intake form</span>
      </div>
      <div className="p-4">
        <IntakeFieldRenderer
          fields={fields}
          values={values}
          onChange={handleChange}
        />
      </div>
    </div>
  )
}
